import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { getCompanyUrl } from 'modules/playbook/selectors'
import { getDemoRequestProductName, getDemoRequestValueProp, getDemoRequestIndustry, getPlaybookType} from 'modules/playbook/selectors'
import { createNewsletterPlaybook, createDemoRequestPlaybook } from 'modules/playbook/actions'

import BotTargeting from 'layouts/OnboardingPlaybookTargetingStep/BotTargeting'

const mapStateToProps = (state) => {
  return {
    companyUrl: getCompanyUrl(state),
    productName: getDemoRequestProductName(state),
    valueProp: getDemoRequestValueProp(state),
    industry: getDemoRequestIndustry(state),
    playbookType: getPlaybookType(state)
  }
}

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    createNewsletterPlaybook,
    createDemoRequestPlaybook
  }, dispatch),
})

export default connect(mapStateToProps, mapDispatchToProps)(BotTargeting)


// WEBPACK FOOTER //
// ./src/containers/OnboardingPlaybook/BotTargetingStep/index.js